<template>
  <div class="parkMap">
    <img class="pao pao3 wow fadeIn" src="@/assets/parkMap7.jpg">
    <div class="pao pao1 wow slideInLeftSelf"></div>
    <div class="pao pao2 wow slideInRightSelf"></div>
    <myMenu :type="2" @zoomChange="initWow"></myMenu>
    <div class="parkMap_content">
      <div class="linear_word">Park Map</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">园区地图</div>
      </div>
      <div class="main wow fadeIn">
        <div class="pM-map wow fadeIn">
          <div class="pM-mimg" id="wrapper">
            <img src="@/assets/parkMap1.jpg" alt="地图" id="pM-mimg-map" />
          </div>
          <div class="pM-btn">
            <img class="s-icon enlarge" src="@/assets/parkMap2.png">
            <img class="s-icon origin" src="@/assets/parkMap4.png">
            <img class="s-icon narrow" src="@/assets/parkMap3.png">
          </div>
          <img class="s-icon view" src="@/assets/parkMap5.png">
        </div>
        <div class="tip wow fadeIn">
          <img src="@/assets/parkMap6.png">
        </div>
      </div>
    </div>
    <myBottom></myBottom>
  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'

import '@/tools/iscroll-zoom.js';
import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'

export default {
  components: { myMenu, myBottom },
  data() {
    return {

    }
  },
  methods: {
    setWow() {
    },
    initWow(zoom) {
      var top = $('.parkMap .pao2').offset().top;
      var offset = zoom >= 1 ? 200 * zoom : (200 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            $(box).removeClass('wow');
          }
        }
      );
      wow.init();
    },
    setMap() {
      $(function () {
        var BS = 0.36
        var myScroll = new IScroll("#wrapper", {
          zoom: true,
          scrollX: true,
          scrollY: true,
          mouseWheel: true,
          wheelAction: "zoom",
          startX: -1600,
          startY: 1200,
          zoomMin: 0.36,
        })
        if (myScroll) {
          myScroll.zoom(BS, 0, 0, 100)
        }
        $(".enlarge").click(function () {
          BS += 0.3;
          if (BS >= 5) {
            BS = 1.0
            return
          }
          myScroll.zoom(BS, 0, 0, 500)
        })
        $(".narrow").click(function () {
          BS -= 0.3;
          if (Math.ceil(BS * 10) / 10 < 0.36) {
            BS = 0.36
            return
          }
          myScroll.zoom(BS, 0, 0, 500)
        })
        $(".origin").click(function () {
          BS = 1
          myScroll.zoom(BS, 0, 0, 500)
        })
        $(".view").click(function () {
          window.open(document.getElementById('pM-mimg-map').src, "_blank")
        })
        // fix: Compatible with FireFox
        document.querySelector(".pM-map").addEventListener("DOMMouseScroll", function (e) {
          e.preventDefault()
          myScroll.refresh()
        })
        document.querySelector(".pM-map").addEventListener("mousewheel", function (e) {
          e.preventDefault()
        })
      });
    },
  },
  mounted() {
    this.setWow();
    this.setMap();
  }
}
</script>

<style lang="scss" scoped>
.parkMap {
  .parkMap_content {
    width: 1320px;
    margin: 110px auto 100px;
    position: relative;
    .main {
      border-radius: 20px;
      background-color: rgb(255, 255, 255);
      box-shadow: 0px 8px 54px 0px rgba(111, 159, 227, 0.3);
      padding: 100px 124px;
      margin-top: 60px;
      position: relative;
    }
    .pM-map {
      position: relative;
    }
    .pM-mimg {
      margin: 0 auto;
      width: 1062px;
      height: 670px;
      overflow: hidden;
      cursor: grab;
      font-size: 0;
      box-shadow: 0px 10px 20px 0px rgba(111, 159, 227, 0.38);
      border-radius: 20px;
    }
    .pM-mimg img {
      max-width: none;
    }
    .pM-map .pM-mimg:active {
      cursor: grabbing;
    }
    .pM-btn {
      position: absolute;
      left: 50%;
      bottom: 20px;
      transform: translate(-50%, 0);
      img {
        cursor: pointer;
        margin: 0 5px;
      }
    }
    .view {
      position: absolute;
      cursor: pointer;
      bottom: 20px;
      right: 100px;
    }
    .tip {
      border-radius: 20px;
      background-color: rgb(255, 255, 255);
      box-shadow: 0px 3px 24px 0px rgba(111, 159, 227, 0.3);
      text-align: center;
      font-size: 0;
      margin-top: 70px;
      padding: 40px 0;
    }
  }
  .pao1 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      67deg,
      rgb(255, 163, 122) 0%,
      rgb(254, 233, 168) 78%,
      rgb(254, 233, 168) 79%
    );
    background-image: -webkit-linear-gradient(
      67deg,
      rgb(255, 163, 122) 0%,
      rgb(254, 233, 168) 78%,
      rgb(254, 233, 168) 79%
    );
    background-image: -ms-linear-gradient(
      67deg,
      rgb(255, 163, 122) 0%,
      rgb(254, 233, 168) 78%,
      rgb(254, 233, 168) 79%
    );
    background-image: linear-gradient(
      67deg,
      rgb(255, 163, 122) 0%,
      rgb(254, 233, 168) 78%,
      rgb(254, 233, 168) 79%
    );
    position: absolute;
    left: -42px;
    top: 991px;
    width: 239px;
    height: 239px;
    opacity: 0.6;
  }
  .pao2 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      120deg,
      rgb(149, 219, 255) 0%,
      rgb(34, 107, 255) 81%
    );
    background-image: -webkit-linear-gradient(
      120deg,
      rgb(149, 219, 255) 0%,
      rgb(34, 107, 255) 81%
    );
    background-image: -ms-linear-gradient(
      120deg,
      rgb(149, 219, 255) 0%,
      rgb(34, 107, 255) 81%
    );
    background-image: linear-gradient(
      120deg,
      rgb(149, 219, 255) 0%,
      rgb(34, 107, 255) 81%
    );
    opacity: 0.7;
    right: -200px;
    top: 1503px;
    width: 303px;
    height: 303px;
  }
  .pao3 {
    width: 100%;
    left: 0;
    top: 1050px;
  }
}
</style>